import { render } from "./EditBillModal.vue?vue&type=template&id=620d1b25"
import script from "./EditBillModal.vue?vue&type=script&lang=js"
export * from "./EditBillModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__